import { Total } from './Summary';
import { useCountdown, clockText } from '../hooks/useCountdown';

const MobileBar = ({ build }) => {
  const countdown = useCountdown();

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 flex items-center justify-between gap-3 border-t border-black/10 bg-white/85 px-4 py-3 pb-[calc(12px+env(safe-area-inset-bottom,0px))] backdrop-blur-xl lg:hidden">
      <div>
        {countdown.active ? (
          <p className="tabular text-[11px] font-semibold text-[#1d9c5e]">Offer ends {clockText(countdown)}</p>
        ) : (
          <p className="text-[10px] text-gray">Live in 24 hours</p>
        )}
        <div className="flex items-baseline">
          <Total build={build} size="text-2xl" />
          
        </div>
      </div>
      <a href={build.waHref} target="_blank" rel="noopener noreferrer" className="btn-wa !py-2.5">
        Order on WhatsApp
      </a>
    </div>
  );
};

export default MobileBar;
